import * as React from 'react';
import { ChangeEvent, useState } from 'react';
import * as S from './SimpleTimeline.styled';
import { AnomalyUI, convertSecondsToMilliseconds, isNil, timelineLabel } from '@shared';
import { TimelinePropsType } from './SimpleTimeline.types';
import { getAnomalyPosition } from './SimpleTimeline.utils';

export const SimpleTimeline = (props: TimelinePropsType) => {
  const { progressPlayed, playedSeconds, onSeekChange, anomalies, videoDuration, isPlaying } =
    props;

  const [isOpenTooltip, setIsOpenTooltip] = useState(false);
  const [tooltipInfo, setTooltipInfo] = useState('');

  const handleTimelineChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSeekChange(Number(e.target.value), isPlaying);
  };

  const renderAnomaly = (anomaly: AnomalyUI) => {
    const { id, start, end, label } = anomaly;
    const tooltipString = `${label} ${timelineLabel(start)} - ${timelineLabel(end)}`;
    const { left, width } = getAnomalyPosition(
      videoDuration,
      convertSecondsToMilliseconds(start),
      convertSecondsToMilliseconds(end)
    );
    const handleOpen = () => {
      setTooltipInfo(tooltipString);
      setIsOpenTooltip(true);
    };
    const handleClose = () => {
      setIsOpenTooltip(false);
      setTooltipInfo('');
    };

    return (
      <S.Anomaly
        onClick={() => onSeekChange(left / 100, true)}
        onMouseOver={handleOpen}
        onFocus={handleOpen}
        onMouseLeave={handleClose}
        onBlur={handleClose}
        key={id}
        style={{ left: `calc(${left}% + 3px)`, width: `${width}%` }}
      />
    );
  };

  return (
    <S.RelativeBox>
      {!isNil(playedSeconds) && <time>{timelineLabel(playedSeconds)}</time>}
      <S.Scheme>
        {anomalies.map((anomaly) => renderAnomaly(anomaly))}
        <S.Timeline
          type='range'
          min={0}
          max={1}
          step='0.00001'
          value={progressPlayed}
          onChange={handleTimelineChange}
        />
        {isOpenTooltip && <strong>{tooltipInfo}</strong>}
      </S.Scheme>
    </S.RelativeBox>
  );
};
